import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Homepage from './components/Homepage';
import BrowseLists from './components/BrowseLists';
import ListDetail from './components/ListDetail';
import BookDetail from './components/BookDetail';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './components/admin/AdminLogin';
import ProtectedRoute from './components/admin/ProtectedRoute';
import Dashboard from './components/admin/pages/Dashboard';
import TopPicksPool from './components/admin/pages/TopPicksPool';
import NewReleases from './components/admin/pages/NewReleases';
import BookOfTheWeek from './components/admin/pages/BookOfTheWeek';
import AuthorSpotlight from './components/admin/pages/AuthorSpotlight';
import CuratedLists from './components/admin/pages/CuratedLists';
import BooksLibrary from './components/admin/pages/BooksLibrary';
import BulkImport from './components/admin/pages/BulkImport';
import Logs from './components/admin/pages/Logs';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/lists" element={<BrowseLists />} />
            <Route path="/list/:id" element={<ListDetail />} />
            <Route path="/book/:id" element={<BookDetail />} />

            {/* Admin login */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected admin routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="top-picks" element={<TopPicksPool />} />
              <Route path="new-releases" element={<NewReleases />} />
              <Route path="book-of-week" element={<BookOfTheWeek />} />
              <Route path="author-spotlight" element={<AuthorSpotlight />} />
              <Route path="curated-lists" element={<CuratedLists />} />
              <Route path="books-library" element={<BooksLibrary />} />
              <Route path="bulk-import" element={<BulkImport />} />
              <Route path="logs" element={<Logs />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
